import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {
    numberWithCommaDataTableTemplate,
    priceDataTableTemplate
} from "../../../../utils/formatters/Numbers";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import PropTypes from "prop-types";

const SettleBreakLoan = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    {props.messagesGrowl}
                    <Grid item xs={6}>
                        <TitlePage title="Tablero de Control \ Incumplimiento"/>
                    </Grid>
                    <Grid item xs={6}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Liquidar" onClick={props.settleBrokenLoan}
                                    style={{marginRight: '.5em'}}/>
                            <Button label="Cancelar" onClick={props.showCancelMessageDialog}
                                    style={{marginRight: '.5em'}} className="p-button-secondary"/>
                            <Button label="Regresar" onClick={props.handleReturnButton}
                                    style={{marginRight: '.5em'}} className="p-button-secondary"/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Préstamo" isBold={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.loanData}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="folio" header="Folio"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="composeName" header="Emisora"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="titles" header="Títulos"
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                            <Column field="price" header="Precio"
                                    body={priceDataTableTemplate} sortable={true}/>
                        </DataTable>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/><br/>
                    </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Garantías" isBold={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.loanCollateralList}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="emisora" header="Emisora"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="titulos" header="Títulos"
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                            <Column field="precioVal" header="Precio Mercado"
                                    body={priceDataTableTemplate} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog visible={props.displayCancelMessageDialog}
                    header={<div className="p-grid p-fluid">
                        <div className="p-col-8" style={{padding: '.1em'}}>
                            <h2 className={"secondary-text"}>Motivo de cancelación</h2>
                        </div>
                        <div className="p-col-2" style={{padding: '.2em'}}>
                            <Button label="Aceptar" onClick={props.cancelBrokenLoan}/>
                        </div>
                        <div className="p-col-2" style={{padding: '.2em'}}>
                            <Button label="Regresar" className="p-button-secondary"
                                    onClick={props.onHideCancelMessageDialog}/>
                        </div>
                    </div>}
                    modal={true} closable={false}
                    onHide={props.onHideCancelMessageDialog}
                    contentStyle={{overflow: 'visible'}}
                    style={{width: "45%",}}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12">
                        <SubtitleLabel header="Indique el motivo de cancelación: " isBold={true}/>
                        <InputTextarea name="cancelMessage" rows={5} cols={30} autoResize={true}
                                       value={props.cancelMessage} onChange={props.saveCancelMessage}/>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
};

export default SettleBreakLoan;

SettleBreakLoan.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
    handleReturnButton: PropTypes.func.isRequired,
    showCancelMessageDialog: PropTypes.func.isRequired,
    displayCancelMessageDialog: PropTypes.bool.isRequired,
    onHideCancelMessageDialog: PropTypes.func.isRequired,
    saveCancelMessage: PropTypes.func.isRequired,
    cancelBrokenLoan: PropTypes.func.isRequired,
    settleBrokenLoan: PropTypes.func.isRequired,
    loanData: PropTypes.array.isRequired,
    loanCollateralList: PropTypes.array.isRequired,
    cancelMessage: PropTypes.string
};